import template from './employee_list_new.html';
import * as Permissions from '../../lib/permission_utils.js';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeListNewViewModel
{
	constructor(page)
	{
		this.page = page;
		this.companies = ko.observableArray();
		this.departments = ko.observableArray();
		this.employees = ko.observableArray()
		this.selected_additionalColumn = ko.observableArray();
		this.filter = ko.observableArray();
		this.date_started = ko.observable();
		this.position = ko.observable();
		this.showDateColumn = ko.observable(false);
		this.showPositionColumn = ko.observable(false);
		this.sort_field = ko.observable('surname');
		this.sort_order = ko.observable('ASC');
		this.current_page_number = ko.observable(1);
		this.current_page_size = ko.observable(15);
		this.page_count = ko.observable(1);
		this.pagination_summary = ko.observable('');
		this.number_of_records = ko.observableArray([15, 20, 50, 100, 200]);
		this.selected_number_of_records = ko.observable(15);
		this.selected_number_of_records.subscribe((newVal) => {
			this.current_page_size(newVal);
			this.page.updateData();
		});

		this.employee_selection = ko.observableArray([
			{ selection: 'All', value: '', filter_remove: true, value_name: tr('All') },
			{ selection: 'Resigned', value: false, filter_remove: false, value_name: tr('Resigned') },
			{ selection: 'Active', value: true, filter_remove: false, value_name: tr('Active') }
		]);

		this.additionalColumns = [ 
			{ additionalColumns: 'date_started' , description: tr('Start date') },
			{ additionalColumns: 'position' , description: tr('Position') }
		];
	}

	page_click(page_number)
	{
		this.current_page_number(page_number);
		this.page.updateData();
	}

	sort_column(column)
	{
		if (column && column.trim() !== '')
		{
			if (this.sort_field() === column)
				this.sort_order(this.sort_order() === 'ASC' ? 'DESC' : 'ASC');
			else
			{
				this.sort_field(column);
				this.sort_order('ASC');
			}
			this.page.updateData();
		}
	}

	selected_viewAdditionalColumns(ids)
	{
		this.selected_additionalColumn(ids);
		this.showDateColumn(ids.includes('date_started'));
		this.showPositionColumn(ids.includes('position'));
	}

	apply_filter(v)
	{
		let filter = [];
		if (v.company)
		{
			filter = {
				value: v.company,
				op: '=',
				field: 'company',
				name: tr('Company'),
				filter_remove: false,
				value_name: v.company
			};
		}

		if (v.department_id)
			filter = {
				value: v.department_id,
				op: '=',
				field: 'department_id',
				name: tr('Department'),
				filter_remove: false,
				value_name: v.department
			};

		if (v.selection)
			filter = {
				value: v.value,
				op: '=',
				field: 'active',
				name: tr('Employees'),
				filter_remove: v.filter_remove,
				value_name: v.value_name
			};

			if (filter)
			{
				// Remove existing filter with the same field
				this.filter.remove(f => f.field === filter.field);

				if (!filter.filter_remove) {
					this.filter.push(filter);
				}
			}

			this.page.updateData({ pageNumber: 1 });
		}

	remove_filter(v)
	{
		this.filter.remove(v);
		this.page.updateData({ pageNumber: 1 });
	}

	async start_linked_leave_tutorial()
	{
		if (Permissions.isLoggedInUser_Admin())
		{
			let res = await Grape.fetches.postJSON('/api/save_setting',
				{
					name: 'system.tutorial_start_linked_leave_tutorial',
					value: true
				}
			);
			let options_before = {
				steps: [
					{
						element: '#employee_list',
						intro: tr('Click on any employee to start assigning leave types!'),
						position: 'left'
					}
				]
			};
			let intro = introJs();
			intro.setOptions(options_before);
			intro.start().onexit(function ()
			{});
		}
	}
	async download_employee_list(is_resigned = false)
	{
		let filters = ko.toJS(this.filter()).filter(f => f.field !== 'active');
		let url = is_resigned 
			? `/download/employee_list_resigned/?filters=${encodeURIComponent(JSON.stringify(filters))}`
			: `/download/employee_list/?filters=${encodeURIComponent(JSON.stringify(filters))}`;
		

	
		// Navigate to the download URL
		location.href = url;
	}
	
}

class EmployeeListPageNew
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new EmployeeListNewViewModel(this);
	}

	async init()
	{
		document.title = tr('Employee List');
		let title = tr('Employee List');
		window.current_page_title(title);
		
		let results = await Promise.all([
			Grape.cache.get('CompanyLookup'),
			Grape.cache.get('DepartmentCompanyList')
		]);
		let [companies, departments] = results;
		this.viewModel.companies(companies);
		this.viewModel.departments(departments);
		if (this.bindings.id != 0)
		{
			let filteredData = [];
			let JSONData = JSON.stringify(departments, (key, value) => {
				if (value.department_id == this.bindings.id) filteredData.push(value);
				return value;
			});
			let dataDepartment = {
				'company_id': null,
				'company': null,
				'department': filteredData[0].department,
				'department_id': filteredData[0].department_id
			};
			this.viewModel.apply_filter(dataDepartment);
		}

		// show active employees be default
		let dataActive = {
			'selection': 'Active',
			'value': true,
			'value_name': 'Active',
			'filter_remove': false
		};
		this.viewModel.apply_filter(dataActive);
		
		/*
			setTimeout(function () {
				if (this.bindings.linked_leave_tutorial == 'startleavetypetutorial=true' && Permissions.isLoggedInUser_Admin())
				{
					this.start_linked_leave_tutorial();
				}
			}, 1000);
		*/

		$('#viewAdditionalColumns').select2({
			placeholder: tr('View Additional Columns'),
			closeOnSelect: false,
			templateResult: this.formatSelect
		});

		$('#viewAdditionalColumns').change(() => {
			let obj = $('#viewAdditionalColumns').select2('data');
			let ids = [];

			obj.forEach((option) => {
				ids.push(option.id);
			});
			this.viewModel.selected_viewAdditionalColumns(ids);
		});
	}

	async updateData(update_options = {})
	{
		let v = await Permissions.checkAccessRights('ViewEmployeeListFull');
		let filter = ko.toJS(this.viewModel.filter());
		let table = v === true ? 'v_all_employees_department' : 'v_restricted_access_list';

		let options = {
			table: table,
			schema: 'savanna',
			offset: (this.viewModel.current_page_number() - 1) * this.viewModel.current_page_size(),
			limit: this.viewModel.current_page_size(),
			sortfield: this.viewModel.sort_field(),
			sortorder: this.viewModel.sort_order(),
			filter: filter, 
			date_started: this.viewModel.date_started(),
			position: this.viewModel.position()
		};

		if (update_options?.pageNumber)
		{
			this.viewModel.current_page_number(update_options.pageNumber);
			options.offset = (update_options.pageNumber - 1) * this.viewModel.current_page_size();
		}

		let res = await Grape.fetches.getJSON('/api/record', options);
		if (res.records != null)
		{
			let records = res.records.map(record => (
				{
					...record,
					fullnames: record.firstname + ' ' + record.surname,
					firstname: record.firstname,
					fulldeptinfo: record.company + ' ' + record.department,
					employee_code: record.employee_code || '',
					id_number: record.id_number || '',
					email: record.email || '',
					company: record.company || '',
					department: record.department || '',
					date_started: record.date_started || '',
					position: record.position || ''
				}
			));
			this.viewModel.employees(records);
			this.viewModel.page_count(Math.ceil(res.total / this.viewModel.current_page_size()));
			this.viewModel.pagination_summary(`Showing ${options.offset + 1} to ${Math.min(options.offset +
				records.length, res.total)} of ${res.total} entries`);
		}
		else
		{
			this.viewModel.employees([]);
			this.viewModel.page_count(1);
			this.viewModel.pagination_summary('No entries');
		}
		Utils.refresh_data_visible_roles();
	}

};

export default {
	route: `[/]employee/list/:id/:linked_leave_tutorial`,
	page_class: EmployeeListPageNew,
	template: template,
	template_filename: 'translation/employee_list_new'
};
